<div [formGroup]="form">
    <cmps-button-group
        [formControlName]="'which'"
        #bgRef
    >
        <ng-container *ngFor="let i of PresentationViewOpts">
            <button
                [class.cmps-cdk-border-color-blue-100]="bgRef.value === i.type"
                [class.cmps-cdk-bg-color-blue-100]="bgRef.value === i.type"
                [class.cmps-cdk-color-white]="bgRef.value === i.type"
                cmpsButtonGroupItem
                [value]="i.type"
            >
                {{ i.tlKey | translate }}
            </button>
        </ng-container>
    </cmps-button-group>
</div>
